import { AppState } from "../appState";

// Base selector to access value range state
export const valueRangeSelector = (state: AppState) => state.valueRangeMasterData;

